import React, { useState, useContext } from "react";
import { ContextEngine } from "../../TractumUI/engine/ContextEngine";
import "./Splitter.css";

const MIN_WIDTH = 100;
const MIN_HEIGHT = 50;

const Splitter = ({ left: leftPanel, center: centerPanel, right: rightPanel, bottom: bottomPanel }) => {
  const { context, updateContext } = useContext(ContextEngine);
  const { left: leftVisible, right: rightVisible, bottom: bottomVisible } = context.panelVisibility;

  const [leftWidth, setLeftWidth] = useState(200);
  const [rightWidth, setRightWidth] = useState(200);
  const [bottomHeight, setBottomHeight] = useState(150);
  

  /* Vertical drag */
  const handleVerticalDrag = (setter, e, side = "left") => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = side === "left" ? leftWidth : rightWidth;

    const onMove = (ev) => {
      const delta = side === "left" ? ev.clientX - startX : startX - ev.clientX;
      setter(Math.max(MIN_WIDTH, startWidth + delta));
    };

    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  /* Horizontal drag */
  const handleHorizontalDrag = (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = bottomHeight;

    const onMove = (ev) => {
      const delta = startY - ev.clientY;
      setBottomHeight(Math.max(MIN_HEIGHT, startHeight + delta));
    };

    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  return (
    <div className="splitter-root">
      <div className="middle-stack">

        {/* Vertical panels: left | center | right */}
        <div className="splitter-vertical">
          {leftVisible && (
            <>
              <div className="panel left" style={{ width: leftWidth }}>{leftPanel}</div>
              <div
                className="divider"
                onMouseDown={(e) => handleVerticalDrag(setLeftWidth, e, "left")}
                onDoubleClick={() => updateContext("panelVisibility.left", false)}
              />
            </>
          )}

          <div className="panel center">{centerPanel}</div>

          {rightVisible && (
            <>
              <div
                className="divider"
                onMouseDown={(e) => handleVerticalDrag(setRightWidth, e, "right")}
                onDoubleClick={() => updateContext("panelVisibility.right", false)}
              />
              <div className="panel right" style={{ width: rightWidth }}>{rightPanel}</div>
            </>
          )}
        </div>

        {/* Horizontal divider + bottom panel */}
        {bottomVisible && (
          <>
            <div
              className="divider-horizontal"
              onMouseDown={handleHorizontalDrag}
              onDoubleClick={() => updateContext("panelVisibility.bottom", false)}
            />
            <div className="panel bottom" style={{ height: bottomHeight }}>{bottomPanel}</div>
          </>
        )}

      </div>
    </div>
  );
};

export default Splitter;
